import axios from 'axios';
import config from '../environment/config';
import { authHeader } from './auth.header';
const API_URL = config.API_URL;



  
export const uploadGalleryData = async (galleryData) => {
  try {
    const response = await axios.post(
      `${API_URL}gallery/upload`,
      galleryData,
      {
        headers: {
          ...authHeader(), 
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data; 
  } catch (error) {
    console.error("Error occurred in uploadGalleryData:", error);
    throw error;
  }
};

export const fetchGalleryData = async () => {
  try {
      return (await axios.get(`${API_URL}gallery/all`, {
          headers: authHeader()
      })).data;
  } catch (error) {
      console.error('Failed to load gallery data', error);
      throw error; 
  }
};

export const deleteGalleryImageById = async (galleryId) => {
  try {
    if(galleryId){
    const response = await axios.delete(`${API_URL}gallery/${galleryId}`, {
      headers: authHeader(),
    });
    return response.data;
  }
  } catch (error) {
    throw error;
  }
};
